<template>
  <div class="container-fluid">

    <div class="row mb-3 mt-2" v-if="benefitData.length > 0">
      <div class="col-12 d-flex ml-2">
        <b-form-radio-group
            v-model="selectedProductType"
            :options="[
            { text: 'SALVUSCARE', value: '1' },
            { text: 'INSURANCE CLAIM', value: '2' }
          ]"
            buttons
            button-variant="outline-primary"
            name="product-type-radios"
        ></b-form-radio-group>
      </div>
    </div>

    <div class="row">
      <div class="col-12 d-flex justify-content-center align-items-center" style="height: 50vh;" v-if="filteredBenefitData.length === 0 && !isLoading">
        <div class="text-center text-muted">
          <p>Benefit data of this product type is not available</p>
        </div>
      </div>

      <div class="col-12 my-3" v-else-if="filteredBenefitData.length > 0">
        <b-card no-body class="card-adjust shadow-sm">
          <b-tabs card active-nav-item-class="font-weight-bold text-primary">

            <b-tab v-for="(product, index) in filteredBenefitData" :key="index" :title="product.type" :active="index === 0">
              <div class="table-responsive mt-2">
                <table class="table table-bordered table-striped table-hover text-center">
                  <thead class="bg-light">
                  <tr>
                    <th class="align-middle text-center text-description font-weight-bold" width="5%">NO</th>
                    <th class="align-middle text-left text-description font-weight-bold" width="30%">BENEFIT</th>
                    <th class="align-middle text-left text-description font-weight-bold" width="20%">BATASAN</th>

                    <th class="align-middle text-center text-description font-weight-bold" style="text-align: center !important;" v-for="plan in product.plans" :key="plan">
                      {{ plan }}
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(benefit, bIndex) in product.benefits" :key="bIndex">

                    <td v-if="benefit.is_group" :colspan="product.plans.length + 3" class="text-left font-weight-bold bg-light text-primary text-description">
                      {{ benefit.benefit_name }}
                    </td>

                    <td v-if="benefit.is_footer" colspan="3" class="text-left font-weight-bold bg-light text-description">
                      {{ benefit.benefit_name }}
                    </td>
                    <td v-if="benefit.is_footer" class="align-middle text-center text-description font-weight-bold bg-light" style="text-align: center !important;" v-for="plan in product.plans" :key="'footer-'+plan">
                         <span v-if="isNaN(benefit.limits[plan])">
                           {{ benefit.limits[plan] }}
                         </span>
                      <span v-else>
                           {{ number(benefit.limits[plan]) }}
                         </span>
                    </td>

                    <td v-if="!benefit.is_group && !benefit.is_footer" class="align-middle text-center text-description">{{ bIndex + 1 }}</td>

                    <td v-if="!benefit.is_group && !benefit.is_footer" class="text-left align-middle text-description">
                      {{ benefit.benefit_name }}
                    </td>

                    <td v-if="!benefit.is_group && !benefit.is_footer" class="text-left align-middle text-description" style="text-transform: capitalize;">
                      {{ benefit.batasan }}
                    </td>

                    <td v-if="!benefit.is_group && !benefit.is_footer" class="align-middle text-center text-description" style="text-align: center !important;" v-for="plan in product.plans" :key="plan">
                         <span v-if="isNaN(benefit.limits[plan])">
                           {{ benefit.limits[plan] }}
                         </span>
                      <span v-else>
                           {{ number(benefit.limits[plan]) }}
                         </span>
                    </td>

                  </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>

          </b-tabs>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: true,
      benefitData: [],
      selectedProductType: '1',
    }
  },
  computed: {
    filteredBenefitData() {
      return this.benefitData
          .filter(item => item.sys_product_type === this.selectedProductType)
          .map(item => ({
            ...item,
            plans: [...(item.plans || [])].sort((a, b) =>
                String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' })
            )
          }));
    }
  },
  async created() {
    this.loadItems();
  },
  methods: {
    async loadItems() {
      let localCoverage = JSON.parse(localStorage.getItem("coverage"));

      if (localCoverage !== null && localCoverage !== undefined) {
        var coverageId = localCoverage.id;
      } else {
        this.$router.push('/select-coverage');
        return;
      }

      this.$router.replace({ query: { ...this.$route.query } }).catch(() => { });

      this.isLoading = true;
      this.$emit('showLoading', true);

      var response = await this.$apiController('get', `/human_resource/get_coverage/benefit_table/${coverageId}`);

      this.$emit('showLoading', false);
      this.isLoading = false;

      if (response.is_ok) {
        this.benefitData = response.data;
      } else {
        this.$emit('showAlert', response.message, "danger");
      }
    },

    number(value) {
      if (!value) return "0";
      if (isNaN(value)) return value;
      let val = (value / 1).toFixed(0).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
}
</script>

<style scoped>
.bg-light {
  background-color: #f8f9fa !important;
}
</style>